export default __webpack_public_path__ + "static/media/06.a0b3aa28.jpg";